import Swal from 'sweetalert2';
import axios from 'axios';
import ProductSearchMixin from '../../mixins/ProductSearchMixin';
import template from './AttachProductAdditionalData.html';

export default {
  template,

  name: 'AttachProductAdditionalData',

  mixins: [ProductSearchMixin],

  props: {
    additionalData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {};
  },

  methods: {
    attachAdditionalData(product) {
      Swal.fire({
        title: 'Er du sikker på du ønsker å utføre handlingen?',
        text: `Det vil føre til at du tilknytter ${this.additionalData.title} til ${product.name}. Du blir sendt til oversikt siden dersom tilknyttningen er vellykket.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Ja, tilknytt!',
        cancelButtonText: 'Avbryt',
      }).then((result) => {
        if (result.value) {
          axios.put('/admin/api/v1/product/attach-additional-data', {
            product_id: product.id,
            additional_data_id: this.additionalData.id,
          })
            .then(() => {
              window.location.href = '/additional-data/product';
            })
            .catch(() => {
              Swal.fire('Feil', 'Kunne ikke utføre tilknytning.', 'error');
            });
        }
      });
    },
  },
};
